import {
  Component,
  OnInit,
  Input,
  Output,
  OnChanges,
  EventEmitter,
} from '@angular/core';
import { PromosService } from '../../services/promos/promos.service';
import { Promo } from '../../models/promo';
import { Router, ActivatedRoute } from '@angular/router';
import { popUpActiveAnimation } from 'app/shared/animations/popup-center.animation';

@Component({
  selector: 'promo-popup',
  templateUrl: './promo-popup.component.html',
  styleUrls: ['./promo-popup.component.scss'],
  animations: [popUpActiveAnimation],
})
export class PromoPopupComponent implements OnChanges {
  @Input() popUpIsActive: boolean;
  // To Promo Highlight
  public firstPromo: Promo;
  public state: string = 'inactive';
  @Output() popUpCloseEvent: EventEmitter<any> = new EventEmitter();

  constructor(private _promoService: PromosService, private _router: Router) {}

  ngOnInit() {
    console.log(this.popUpIsActive);
    this._promoService.getPromos().then(data => {
      this.firstPromo = data[0];
      // console.log('active promo:', this.firstPromo);
    });
  }

  closePromo(e) {
    if (this.popUpIsActive) {
      this.popUpIsActive = false;
      this.popUpCloseEvent.emit({ popUpActive: this.popUpIsActive });
    }
  }

  goToMenu() {
    this._router.navigate(['menu']);
    this.closePromo(null);
  }

  ngOnChanges(changes) {
    if (changes.popUpIsActive.currentValue === true) {
      this.state = 'active';
    } else {
      this.state = 'inactive';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/promo/promo-popup/promo-popup.component.ts